import React from 'react';
import { ReactComponent as Icon } from '../icons/icon-cross.svg';

// Mostly duplicate from picasso/client/src/components/modal.jsx
const widthDict = { lg: 700, md: 500, sm: 400 };
const styles = {
  backdrop: {
    backgroundColor: 'rgba(0, 0, 0, 0.75)',
    bottom: 0,
    left: 0,
    position: 'fixed',
    right: 0,
    top: 0,
  },
  modal: {
    backgroundColor: 'white',
    maxHeight: '90%',
    overflow: 'auto',
    padding: 28,
    width: widthDict.md,
  },
  title: {
    margin: 0,
  },
};

export const Modal = ({ children, title, onClose, style, onKeyDown }) => {
  React.useEffect(() => {
    if (onKeyDown) {
      window.addEventListener('keydown', onKeyDown);
      return () => {
        window.removeEventListener('keydown', onKeyDown);
      };
    }
  }, []);
  return (
    <div
      className="flex justify-center items-center"
      style={styles.backdrop}
      onClick={onClose}
    >
      <div style={style || styles.modal} onClick={(e) => e.stopPropagation()}>
        <div className="flex justify-between align-center mb4">
          <h2 className="m0">{title}</h2>
          <Icon style={{ cursor: 'pointer' }} onClick={onClose} />
        </div>
        {children}
      </div>
    </div>
  );
};
